import {taskByIdApiPath} from './api-url-helpers'
import {fetchCAPI} from '@github-ui/copilot-shared-ui/capi/fetch-capi'
import {replayTaskHistoryEvents, type TaskHistorySession} from './replay-task-history-events'

export interface FetchTaskHistoryOptions {
  copilotApiUrl?: string
  signal?: AbortSignal
}

export async function fetchTaskHistory(
  taskId: string,
  options: FetchTaskHistoryOptions = {},
  fetcher: typeof fetchCAPI = fetchCAPI,
): Promise<TaskHistorySession[]> {
  return replayTaskHistoryEvents(await fetchTaskAhpEvents(taskId, options, fetcher))
}

async function fetchTaskAhpEvents(
  taskId: string,
  {copilotApiUrl, signal}: FetchTaskHistoryOptions,
  fetcher: typeof fetchCAPI = fetchCAPI,
): Promise<unknown[]> {
  const response = await fetcher({
    path: `${taskByIdApiPath(taskId)}/events`,
    copilotApiUrl,
    additionalHeaders: {Accept: 'application/vnd.github.ahp+json'},
    signal,
  })
  const data: unknown = await response.json()
  if (
    typeof data !== 'object' ||
    data === null ||
    !('events' in data) ||
    !Array.isArray(data.events) ||
    !('total' in data) ||
    !Number.isInteger(data.total) ||
    (data.total as number) < 0
  ) {
    throw new Error('Chat history events response is malformed.')
  }
  if (data.total !== data.events.length) {
    throw new Error('Chat history events response has an inconsistent total.')
  }

  return data.events
}
